import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectBestLimits: "selectBestLimits [Action]",
  selectBestLimitsLoading: "selectBestLimitsLoading [Action]",
  selectBestLimitsAsync: "selectBestLimitsAsync [Action]",
  selectBestLimitsReset: "selectBestLimitsReset [Action]",
};
const inistiaState = {
  data: [],
  loading: true,
  total: 0,
};

export const select_best_limits_Reducer = (
  state = inistiaState,
  { type, payload },
) => {
  switch (type) {
    case actionTypes.selectBestLimits:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectBestLimitsLoading:
      return {
        ...state,
        loading: payload,
      };
    case actionTypes.selectBestLimitsReset:
      return {
        ...inistiaState,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectBestLimitsLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "offlineorder",
    method_type: "select_best_limits",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectBestLimits,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectBestLimitsLoading,
      payload: false,
    });
  }
}

export function* selectBestLimits() {
  yield takeLatest(actionTypes.selectBestLimitsAsync, handleWorker);
}
